import React from 'react';

// The loading indicator (the same as Manifold Manager's): a spinner in the brand's red with what is loading under it.
// `page` fills most of the screen, for a whole page that has nothing to show yet; otherwise it sits in a list, a tab or
// a card. `small` is a compact one for a dialog.
const Loading = ({ label = 'Cargando...', page = false, small = false }) => (
  <div
    role="status"
    aria-live="polite"
    className="d-flex flex-column align-items-center justify-content-center text-center"
    style={{ minHeight: page ? '60vh' : small ? 0 : 160, gap: small ? 8 : 14, padding: small ? '12px 0' : '24px 0' }}
  >
    <div
      className="spinner-border"
      style={{ width: small ? '1.6rem' : '3rem', height: small ? '1.6rem' : '3rem', color: 'var(--mm-brand)', borderWidth: small ? '0.2em' : '0.3em' }}
    />
    <span className="text-muted" style={{ fontSize: small ? '0.85rem' : '0.95rem' }}>{label}</span>
  </div>
);

export default Loading;
